export default {
  'userandregister-result.login.userName': '賬戶',
  'userandregister-result.login.password': '密碼',
  'userandregister-result.login.message-invalid-credentials': '賬戶或密碼錯誤（admin/ant.design）',
  'userandregister-result.login.message-invalid-verification-code': '驗證碼錯誤',
  'userandregister-result.login.tab-login-credentials': '賬戶密碼登錄',
  'userandregister-result.login.tab-login-mobile': '手機號登錄',
  'userandregister-result.login.remember-me': '自動登錄',
  'userandregister-result.login.forgot-password': '忘記密碼',
  'userandregister-result.login.sign-in-with': '其他登錄方式',
  'userandregister-result.login.signup': '註冊賬戶',
  'userandregister-result.login.login': '登錄',
  'userandregister-result.register.register': '註冊',
  'userandregister-result.register.get-verification-code': '獲取驗證碼',
  'userandregister-result.register.sign-in': '使用已有賬戶登錄',
  'userandregister-result.register-result.msg': '妳的賬戶：{email} 註冊成功',
  'userandregister-result.register-result.activation-email':
    '激活郵件已發送到妳的郵箱中，郵件有效期為24小時。請及時登錄郵箱，點擊郵件中的鏈接激活帳戶。',
  'userandregister-result.register-result.back-home': '返回首頁',
  'userandregister-result.register-result.view-mailbox': '查看郵箱',
  'userandregister-result.navBar.lang': '語言',
};
